require('./jquery.scrollbar');
module.exports = 'jQueryScrollbar';




//////////////////
// WEBPACK FOOTER
// ./~/jquery.scrollbar/index.js
// module id = 758
// module chunks = 1